import React from 'react';

const IconLogo = ({ color, width, height }) => {
  const colorfill = color || '#FFFFFF';
  const widthIcon = width || '26';
  const heightIcon = height || '26';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26 26"
      width={widthIcon}
      height={heightIcon}
      aria-labelledby="title"
    >
      <title id="title">Home</title>
      <g clipPath="url(#clip0)">
        <path
          d="M3.71429 0C1.66623 0 0 1.66623 0 3.71429C0 5.76235 1.66623 7.42859 3.71429 7.42859C5.76235 7.42859 7.42859 5.76235 7.42859 3.71429C7.42859 1.66623 5.76235 0 3.71429 0Z"
          fill="#FF6C00"
        />
        <path
          d="M22.2857 0C20.2376 0 18.5714 1.66623 18.5714 3.71429C18.5714 5.76235 20.2376 7.42859 22.2857 7.42859C24.3338 7.42859 26 5.76235 26 3.71429C26 1.66623 24.3338 0 22.2857 0Z"
          fill="#18191F"
        />
        <path
          d="M13 0C10.9519 0 9.28571 1.66623 9.28571 3.71429C9.28571 5.76235 10.9519 7.42859 13 7.42859C15.0481 7.42859 16.7143 5.76235 16.7143 3.71429C16.7143 1.66623 15.0481 0 13 0Z"
          fill="#7C9AF2"
        />
        <path
          d="M22.2857 18.5714C20.2376 18.5714 18.5714 20.2376 18.5714 22.2857C18.5714 24.3338 20.2376 26 22.2857 26C24.3338 26 26 24.3338 26 22.2857C26 20.2376 24.3338 18.5714 22.2857 18.5714Z"
          fill="#7C9AF2"
        />
        <path
          d="M22.2857 9.28571C20.2376 9.28571 18.5714 10.9519 18.5714 13C18.5714 15.0481 20.2376 16.7143 22.2857 16.7143C24.3338 16.7143 26 15.0481 26 13C26 10.9519 24.3338 9.28571 22.2857 9.28571Z"
          fill="#18191F"
        />
        <path
          d="M13 9.28571C10.9519 9.28571 9.28571 10.9519 9.28571 13C9.28571 15.0481 10.9519 16.7143 13 16.7143C15.0481 16.7143 16.7143 15.0481 16.7143 13C16.7143 10.9519 15.0481 9.28571 13 9.28571Z"
          fill="#FF6C00"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="26" height="26" fill={colorfill} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconLogo;
